/**
 * A new site ordered in one go (ADR-0059): its domain bought through 2d2s,
 * or one already held, and the site made on it from a template build.
 *
 *   paying          the request that made the order is paying for the domain
 *   purchasing      2d2s is buying it and making its Cloudflare zone
 *   awaiting_scope  bought; waiting until the panel may write its DNS
 *   creating        the site is being made (the `site.create` job)
 *   done / failed   nothing more happens
 */
export const SITE_ORDER_STATES = ['paying', 'purchasing', 'awaiting_scope', 'creating', 'done', 'failed'] as const;
export type SiteOrderState = (typeof SITE_ORDER_STATES)[number];

/** States in which the worker still moves an order on. */
export const SITE_ORDER_ACTIVE: readonly SiteOrderState[] = ['paying', 'purchasing', 'awaiting_scope', 'creating'];

/**
 * How long each wait may last before the order is given up. The domain
 * bought stays in 2d2s whatever happens; nothing is ever paid for twice.
 */
export const SITE_ORDER_LIMITS = {
  /** 2d2s has not shown the payment: it is not asked again, the owner checks in 2d2s. */
  paymentMs: 15 * 60_000,
  /** A payment that was never sent (the request that made the order died first). */
  unsentMs: 2 * 60_000,
  /** Buying and the Cloudflare zone take minutes; a day is a stuck purchase. */
  purchaseMs: 24 * 60 * 60_000,
  /** The domain under the panel's write tags, its zone readable. */
  scopeMs: 2 * 60 * 60_000,
} as const;

export function isSiteOrderActive(state: string): boolean {
  return (SITE_ORDER_ACTIVE as readonly string[]).includes(state);
}
